import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { ACTION_CODES } from "@/domain/actions.interface";

const actionValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup
      .string()
      .required("This field is required")
      .min(2, t("validations.min_length", { count: 2 }))
      .max(120, t("validations.max_length", { count: 120 })),
    code: yup
      .string()
      .required("This field is required")
      .oneOf(ACTION_CODES, "Invalid code"),
    description: yup
      .string()
      .required("This field is required")
      .max(500, t("validations.max_length", { count: 500 })),
    status: yup
      .string()
      .required("This field is required")
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status"),
    type: yup
      .string()
      .oneOf(["MENU_OPTION", "OPTION", ""], "Invalid type")
      .default(""),
    link: yup.string().default(""),
    order: yup
      .number()
      .typeError("Order must be a number")
      .required("This field is required")
      .min(0, "Order must be 0 or greater"),
    icon: yup.string().default(""),
    subActions: yup.array().of(yup.string().required()).default([]),
  });

export type ActionFormData = InferType<
  ReturnType<typeof actionValidationSchema>
>;

export default actionValidationSchema;
